export default __webpack_public_path__ + "static/media/avatar_indian_boy2.9b5ce15b.mp3";